import { select, call, put } from 'redux-saga/effects';
import { get } from 'lodash';
import { API } from '../../api';

const getServerConfig = ({ serverConfig }) => serverConfig;

export function* shareLayer(action) {
  const serverConfig = yield select(getServerConfig);
  const layerId = get(action, 'payload.layerId');
  const userIds = get(action, 'payload.userIds');

  if (userIds.length) {
    const path = `/layer/${serverConfig.namespace}/share`;
    const payload = {
      body: {
        layer_id: layerId,
        user_ids: userIds,
      },
    };
    const result = yield call(API, 'post', 'api', path, payload);
    yield put({
      type: 'ADD_USERS_TO_LAYER',
      payload: {
        layerId,
        users: [result.user].filter(Boolean),
      },
    });
  }
}
